import React from "react";
import { useTranslation } from "react-i18next";

const AppContainer = ({ drawerStyle, children }) => {
  const { i18n } = useTranslation();
  return (
    <div
      style={{ direction: i18n.dir() === "rtl" ? "rtl" : "ltr" }}
      className={`app-container ${drawerStyle}`}
    >
      {children}
    </div>
  );
};

export default AppContainer;
